export const apiCreate = (): string => '/warnings/create'
export const apiList = (id?: string): string =>
  !id ? '/warnings/' : `/warnings/view/${id}`
export const apiUpdate = (id: string): string => `/warnings/update/${id}`
export const apiDelete = (id: string): string => `/warnings/delete/${id}`
